module.exports = __webpack_public_path__ + "img/DownArrowRed.af6bbbbe.svg";